import BreadCrumb from "Components/Common/BreadCrumb";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import Filters from "../Filters";
import ThematicAreaDistribution from "./ThematicAreaDistribution";
import TotalSupport from "../Widgets/TotalSupport";
import TotalContracts from "../Widgets/TotalContracts";
import TotalMDAs from "../Widgets/TotalMDAs";
import TotalPartners from "../Widgets/TotalPartners";

const ThematicAnalysisReport = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Thematic Analysis Report"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "Reports" },
            ]}
          />

          <Row>
            <Col lg={12}>
              <Filters />
            </Col>
          </Row>
          <Row>
            <Col lg={3} md={4}>
              <TotalSupport />
            </Col>
            <Col lg={3} md={4}>
              <TotalContracts />
            </Col>
            <Col lg={3} md={4}>
              <TotalMDAs />
            </Col>
            <Col lg={3} md={4}>
              <TotalPartners />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <ThematicAreaDistribution />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ThematicAnalysisReport;
